import { Body, Heading } from '@assembly-js/design-system';
import React from 'react';

interface SettingsGroupProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  /** A button beside the title that adds to the group, e.g. "Create key". */
  action?: React.ReactNode;
  /** Usually a single SettingsCard. */
  children: React.ReactNode;
}

export const SettingsGroup = ({
  title,
  description,
  action,
  children,
}: SettingsGroupProps) => (
  <section>
    <div className="flex items-center gap-3">
      <div className="min-w-0 flex-1">
        <Heading size="lg" tag="h2" className="mb-0! text-black-heading">
          {title}
        </Heading>
        {description && (
          <Body size="sm" className="mt-px leading-[21px] text-secondary">
            {description}
          </Body>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
    <div className="mt-2.5">{children}</div>
  </section>
);
